import { Box, Typography, TextField, Button, Grid } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { ClientFormData } from '../../../../types/organization';

interface ClientFormProps {
  data: ClientFormData;
  onUpdate: (field: string, value: any) => void;
  onNext: () => void;
}

export default function ClientForm({ data, onUpdate, onNext }: ClientFormProps) {
  const { control, handleSubmit } = useForm({
    defaultValues: data,
  });

  const onSubmit = (formData: ClientFormData) => {
    onUpdate('client', formData);
    onNext();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Client Information
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="firstName"
            control={control}
            rules={{ required: 'First name is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="First Name"
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="lastName"
            control={control}
            rules={{ required: 'Last name is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Last Name"
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="email"
            control={control}
            rules={{
              required: 'Email is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Email"
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Controller
            name="phone"
            control={control}
            rules={{ required: 'Phone number is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Phone"
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid> */}
        <Grid item xs={12}>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <TextField
                type="tel"
                {...field}
                label="Phone (Optional)"
                fullWidth
                inputProps={{
                  inputMode: 'tel',
                }}
              />
            )}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button type="submit" variant="contained" disableElevation sx={{ minWidth: 120 }}>
          Next
        </Button>
      </Box>
    </form>
  );
}
